import styled from 'styled-components'

export const PatientListingPageContainer = styled.div`
  margin: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 100%;
`

export const PatientListingContainerForClinic = styled.div`
  width: 100%;
  overflow-x: auto;
`
